import * as React from 'react';
import { Link } from 'react-router-dom';

export default function CodingProjects() {
  const projects = [
    {
      title: 'Quiz App',
      description: 'Randomized quiz project.',
      path: '/quiz'
    },
    {
      title: 'Species Spotter',
      description: 'Picture/species sorting project.',
      path: '/speciesspotter'
    },
    {
      title: 'Waterbody Manager',
      description: 'Manage waterbodies for the hidden TRMNL water display.',
      path: '/watermanagement'
    }
  ];

  return (
    <div style={{ padding: 40 }}>
      <h1>Coding Projects</h1>

      <p style={{ fontSize: 18, marginBottom: 30 }}>
        Select a project below.
      </p>

      <div
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: 20
        }}
      >
        {projects.map(project => (
          <Link
            key={project.path}
            to={project.path}
            style={{ textDecoration: 'none' }}
          >
            <div
              style={{
                width: 260,
                minHeight: 130,
                padding: 24,
                borderRadius: 18,
                background: '#f5f5f5',
                color: '#111',
                boxShadow: '0 6px 14px rgba(0,0,0,0.25)',
                transition: 'transform 0.15s ease, background 0.15s ease',
                cursor: 'pointer'
              }}
              onMouseEnter={e => {
                e.currentTarget.style.transform = 'translateY(-4px)';
                e.currentTarget.style.background = '#e6f0ff';
              }}
              onMouseLeave={e => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.background = '#f5f5f5';
              }}
            >
              <h2 style={{ color: '#111', marginBottom: 10 }}>
                {project.title}
              </h2>

              <p style={{ color: '#333', margin: 0 }}>
                {project.description}
              </p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
